import "../../../index88.css";
import { jsxs as p, jsx as e } from "react/jsx-runtime";
import { useContext as S, useRef as T, useCallback as b } from "react";
import { TableSortingLineIcon as I, ArrowDropUpLineIcon as B, ArrowDropDownLineIcon as g } from "@ifrc-go/icons";
import { i as c } from "../../../type-BFTbooL7.js";
import { _ as f } from "../../../cs-piwRuCFZ.js";
import x from "../../Button/index.js";
import w from "../../InfoPopup/index.js";
import P from "../../../hooks/useTranslation.js";
import { SortContext as k } from "../useSorting.js";
const L = "common", j = {
  sortTableButtonTitle: "Sort Table"
}, y = {
  namespace: L,
  strings: j
}, A = "_header-cell_vn24d_1", R = "_sort-button_vn24d_8", H = "_icon_vn24d_12", U = "_info-popup-icon_vn24d_17", t = {
  headerCell: A,
  sortButton: R,
  icon: H,
  infoPopupIcon: U
};
function V(d) {
  const {
    className: u,
    titleClassName: _,
    title: C,
    name: r,
    sortable: v,
    defaultSortDirection: a = "asc",
    infoTitle: l,
    infoDescription: m
  } = d, {
    sorting: i,
    setSorting: s
  } = S(k), N = P(y), o = (i == null ? void 0 : i.name) === r ? i.direction : void 0, h = T(null), D = b(
    () => {
      if (c(s))
        return;
      let n;
      c(o) ? n = a : o === "asc" ? n = "dsc" : o === "dsc" && (n = "asc"), s(n ? { name: r, direction: n } : void 0);
    },
    [r, s, o, a]
  );
  return /* @__PURE__ */ p(
    "div",
    {
      ref: h,
      className: f(
        u,
        t.headerCell
      ),
      children: [
        v && /* @__PURE__ */ p(
          x,
          {
            name: void 0,
            variant: "tertiary",
            onClick: D,
            title: N.sortTableButtonTitle,
            className: t.sortButton,
            children: [
              c(o) && /* @__PURE__ */ e(I, { className: t.icon }),
              o === "asc" && /* @__PURE__ */ e(B, { className: t.icon }),
              o === "dsc" && /* @__PURE__ */ e(g, { className: t.icon })
            ]
          }
        ),
        /* @__PURE__ */ e("div", { className: f(_, t.title), children: C }),
        l && m && /* @__PURE__ */ e(
          w,
          {
            className: t.infoPopupIcon,
            title: l,
            description: m
          }
        )
      ]
    }
  );
}
export {
  V as default
};
